import * as Yup from 'yup';
import { AccountContactPerson } from '../../../../../../shared/types/modules/account';

export const initialValues: AccountContactPerson = {
    document: '',
    personType: '',
    typeDocument: '',
    name: '',
    lastName: '',
    gender: '',
    isLGBTIQ: false,
    cellPhone: '',
    phone: '',
    email: '',
};

export const validationSchema = (juridicalId?: string) =>
    Yup.object({
        document: Yup.string()
            .required('La identificación es obligatoria')
            .max(
                20,
                'La identificación debe tener 20 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9]*$/,
                'La identificación solo debe contener caracteres alfanuméricos'
            ),
        personType: Yup.string().required('El tipo de persona es obligatorio'),
        typeDocument: Yup.string().required(
            'El tipo de documento es obligatorio'
        ),
        name: Yup.string().when('personType', {
            is: juridicalId,
            then: () =>
                Yup.string()
                    .required('El campo razón social es obligatorio')
                    .max(
                        50,
                        'El campo razón social debe tener 50 caracteres alfanuméricos como máximo'
                    )
                    .matches(
                        /^[a-zA-Z\s]*$/,
                        'El campo razón social solo debe contener caracteres alfabéticos'
                    ),
            otherwise: () =>
                Yup.string()
                    .required('El campo nombres es obligatorio')
                    .max(
                        25,
                        'El campo nombres debe tener 25 caracteres alfanuméricos como máximo'
                    )
                    .matches(
                        /^[a-zA-Z\s]*$/,
                        'El campo nombres solo debe contener caracteres alfabéticos'
                    ),
        }),
        lastName: Yup.string().when('personType', {
            is: juridicalId,
            otherwise: () =>
                Yup.string()
                    .required('El campo apellidos es obligatorio')
                    .max(
                        25,
                        'El campo apellidos debe tener 25 caracteres alfanuméricos como máximo'
                    )
                    .matches(
                        /^[a-zA-Z\s]*$/,
                        'El campo apellidos solo debe contener caracteres alfabéticos'
                    ),
        }),
        gender: Yup.string().when('personType', {
            is: juridicalId,
            otherwise: () => Yup.string().required('El genero es obligatorio'),
        }),
        cellPhone: Yup.string()
            .required('El celular es obligatorio')
            .max(
                150,
                'El celular debe tener 150 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9]*$/,
                'El celular solo debe contener caracteres alfanuméricos'
            ),
        phone: Yup.string()
            .max(
                150,
                'El teléfono debe tener 150 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9]*$/,
                'El teléfono solo debe contener caracteres alfanuméricos'
            ),
        email: Yup.string()
            .required('El e-mail es obligatorio')
            .max(
                254,
                'El e-mail debe tener 254 caracteres alfanuméricos como máximo'
            )
            .email('El e-mail es invalido')
            .test('Validate Email', 'El e-mail es inválido', (value) => {
                const re =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(value).toLowerCase());
            }),
        isLGBTIQ: Yup.boolean()
            .required('La respuesta para LGBTIQ es obligatoria')
            .oneOf(
                [true, false],
                'La respuesta para LGBTIQ debe ser seleccionada'
            ),
    });
